import { InputModel } from "../components/FormGenerator";
import { maritalStatusValue } from "./utilities";

export const initial_edit_profile = (initialValue) => [
  new InputModel({
    is_hidden: true,
    key: "is_private",
    value: false,
  }),
  new InputModel({
    label: "First Name",
    value: initialValue ? initialValue["first_name"] : "",
  }),
  new InputModel({
    label: "Last Name",
    value: initialValue ? initialValue["last_name"] : "",
  }),
  new InputModel({
    label: "NIK",
    value: initialValue ? initialValue["nik"] : "",
  }),
  new InputModel({
    label: "Email",
    read_only: true,
    value: initialValue ? initialValue["email"] : "",
  }),
  new InputModel({
    label: "Job Title",
    value: initialValue ? initialValue["job_title"] : "",
  }),
  new InputModel({
    label: "Address",
    value: initialValue ? initialValue["address"] : "",
  }),
  new InputModel({
    label: "Short Bio",
    value: initialValue ? initialValue["short_bio"] : "",
  }),
  new InputModel({
    label: "COMPANY",
    is_divider: true,
  }),
  new InputModel({
    label: "Organization Name",
    read_only: true,
    value: initialValue ? initialValue["organization_name"] : "",
  }),
  new InputModel({
    label: "Department",
    key: "department_name",
    read_only: true,
    value: initialValue ? initialValue["department_name"] : "",
  }),
  new InputModel({
    label: "Division",
    key: "division_name",
    read_only: true,
    value: initialValue ? initialValue["division_name"] : "",
  }),
  new InputModel({
    label: "Area",
    key: "area_name",
    mandatory: true,
    value: initialValue ? initialValue["area_name"] : "",
  }),
  new InputModel({
    label: "PERSONAL DETAIL",
    is_divider: true,
  }),
  new InputModel({
    label: "Phone Number",
    im_type: "number",
    value: initialValue ? initialValue["phone_number"] : "",
  }),
  new InputModel({
    label: "DOB",
    key: "date_of_birth",
    form_tipe: "datepicker",
    value:
      initialValue && initialValue["date_of_birth"]
        ? Date.parse(initialValue["date_of_birth"])
        : new Date(),
  }),
  new InputModel({
    label: "Marital Status",
    key: "martial_status",
    read_only: false,
    form_tipe: "select",
    select_options: [
      { name: "Single", value: 1 },
      { name: "Married", value: 2 },
      { name: "Divorce", value: 3 },
    ],
    value: initialValue
      ? maritalStatusValue(initialValue["martial_status"])
      : 0,
  }),
  new InputModel({
    label: "Gender",
    key: "gender",
    read_only: false,
    form_tipe: "select",
    select_options: [
      { name: "Male", value: 0 },
      { name: "Female", value: 1 },
    ],
    value: initialValue ? initialValue["gender"] : 0,
  }),
  // new InputModel({
  //     label: "Golongan Darah",
  //     value: initialValue ? initialValue[''] : ""
  // }),
  new InputModel({
    label: "SOCIAL MEDIA",
    is_divider: true,
  }),

  new InputModel({
    label: "Facebook URL",
    key: "facebook",
    mandatory: false,
    value: initialValue ? initialValue["facebook"] : "",
  }),
  new InputModel({
    label: "Twitter URL",
    key: "twitter",
    mandatory: false,
    value: initialValue ? initialValue["twitter"] : "",
  }),
  // new InputModel({
  //     label: "Instagram URL",
  //     key: "instagram",
  //     mandatory: false,
  //     value: initialValue ? initialValue[''] : ""
  // }),
  new InputModel({
    label: "Linkedin URL",
    key: "linkedin",
    mandatory: false,
    value: initialValue ? initialValue["linkedin"] : "",
  }),
  new InputModel({
    label: "Website URL",
    key: "website",
    mandatory: false,
    value: initialValue ? initialValue["website"] : "",
  }),
];
